import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  ActivatedRouteSnapshot,
  UrlSegment,
  NavigationEnd,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { takeWhile } from 'rxjs/operators';

import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MobileCheckServiceService } from '../../../services/mobile-check-service.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-breadcrumb',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  settings: Settings;
  pageTitle: string;
  breadcrumbs: {
    name: string;
    url: string;
  }[] = [];

  // private alive = true;

  constructor(
    public appSettings: AppSettings,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public title: Title,
    public auth: AuthService,
    private mobileCheck: MobileCheckServiceService
  ) {
    this.settings = this.appSettings.settings;
    // this.router.events.pipe(takeWhile(() => this.alive)).subscribe(event => {
    //     if (event instanceof NavigationEnd) {
    //         this.breadcrumbs = [];
    //         this.parseRoute(this.router.routerState.snapshot.root);
    //         this.pageTitle = '';
    //         this.breadcrumbs.forEach(breadcrumb => {
    //             this.pageTitle += ' / ' + breadcrumb.name;
    //         })
    //         this.title.setTitle(this.settings.name + this.pageTitle);
    //     }
    // });
  }

  ngOnInit() {
    this.breadcrumbs = [];
    this.parseRoute(this.router.routerState.snapshot.root);
    this.pageTitle = '';
    this.breadcrumbs.forEach((breadcrumb) => {
      this.pageTitle += ' / ' + breadcrumb.name;
    });
    this.title.setTitle(this.settings.name + this.pageTitle);
  }

  // ngOnDestroy(): void {
  //   this.alive = false;
  // }

  parseRoute(node: ActivatedRouteSnapshot) {
    if (node.data['breadcrumb']) {
      if (node.url.length || node.pathFromRoot.length) {
        let urlSegments: UrlSegment[] = [];
        node.pathFromRoot.forEach((routerState) => {
          urlSegments = urlSegments.concat(routerState.url);
        });
        const url = urlSegments
          .map((urlSegment) => {
            return urlSegment.path;
          })
          .join('/');

        let tempName = node.data['breadcrumb'];
        if (node.params[tempName]) {
          let value = node.params[tempName];

          if (tempName.indexOf('-slug') > -1) {
            const tokens = value.replace('-amp-', '-&-').split('-');
            if (!isNaN(tokens[0])) {
              tokens.shift();
            }
            value = tokens.join(' ').toUpperCase();
          }

          tempName = value;
        }

        if (tempName.length === 0 && node.url.length > 0) {
          tempName = node.url[0].path;
        }

        if (node.data['breadcrumbPrefix']) {
          tempName = `${node.data['breadcrumbPrefix']}${tempName}`;
        }

        if (tempName) {
          if (!this.breadcrumbs.find((b) => b.name === tempName)) {
            this.breadcrumbs.push({
              name: tempName,
              url: '/' + url,
            });
          }
        }
      }
    }
    if (node.firstChild) {
      this.parseRoute(node.firstChild);
    }
  }

  public closeSubMenus() {
    const menu = document.querySelector('#menu0');
    if (menu) {
      for (let i = 0; i < menu.children.length; i++) {
        const child = menu.children[i].children[1];
        if (child) {
          if (child.classList.contains('show')) {
            child.classList.remove('show');
            menu.children[i].children[0].classList.add('collapsed');
          }
        }
      }
    }
  }

  public breadcrumbName(name): string {
    const path = `/cart/${name}`;
    if (this.router.url.includes(path) && name !== 'Checkout') {
      return `Order #${name}`;
    }
    return name;
  }

  get mobile(): boolean {
    return this.mobileCheck.mobile;
  }
}
